export enum CreditCardFormFields {
  CC_NUMBER = 'creditCardNumber',
  EXPIRATION_MONTH = 'expirationMonth',
  EXPIRATION_YEAR = 'expirationYear',
  CARD_CVV = 'cardVerificationNumber',
}

export const CreditCardFormInitialState = {
  [CreditCardFormFields.CC_NUMBER]: '',
  [CreditCardFormFields.EXPIRATION_MONTH]: '',
  [CreditCardFormFields.EXPIRATION_YEAR]: '',
  [CreditCardFormFields.CARD_CVV]: '',
};
